export default __webpack_public_path__ + "static/media/searchIcon.9c68766f.svg";